/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

var scrollTop;
var bannerHeight;

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        

        jQuery('.bot_menu_phone').on('click', function(ev){
          ev.preventDefault();
        
          console.log("ABRO MENÚ");   
          jQuery('.bot_menu_phone').toggleClass('abierto');
          jQuery('nav').slideToggle();
          jQuery('.row_menu').toggleClass('op_1');

         // jQuery('.brand_fixed').toggleClass('hide_brand');
      
      
        });
       

        resize();
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      jQuery.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  jQuery(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


window.onload=function(){


  var efecto="slide";
  if(jQuery(window).width()>1024){ 
    efecto = "fade"; 
  }


  jQuery('.nav-primary a:not(".no_nav") ,  .gotoNext').on('click', function(ev){
    ev.preventDefault();
    var goTo = jQuery(this).attr('href');
    goTo = jQuery(goTo).offset();

    jQuery('body,html').animate({ scrollTop: goTo.top}, 400);  

    if(jQuery('.bot_menu_phone').hasClass('abierto') ){

      jQuery('.bot_menu_phone').trigger('click');

    }


  });
 
  var  swiperSingle = new Swiper('.swc-single_ok', {
    // Enable lazy loading
    effect: efecto,
    loop: true,
    lazy: true,
    preload:true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '#sg_xl_next',
      prevEl: '#sg_xl_prev',
    },

    on:{
      init:function(){
        jQuery('.baix_punts').width( jQuery('.swc-single_ok').width()   );
        jQuery('.baix_punts').height( jQuery('.swc-single_ok').height()   );
    
        /*
        var tmpOff = jQuery('.swip_fotos').offset();
        alert(tmpOff.top);

        jQuery('.baix_punts').css('top', tmpOff.top  );
        jQuery('.baix_punts').css('left',  tmpOff.left);
        */

      }
    }

  });



  swiperSingle.on('init', function () {

  


  });
//


//


  /*
    thumbs: {
      swiper: swiperThumbsSingle,
    }



    duration: 400
  */
/*
var controller = new ScrollMagic.Controller(); 
var arrScenes = [];
var arrNames = [];
//.addIndicators({name:""+tmpID})


jQuery('.trig_cont_sec').each(function(i){

  var tmpID = jQuery(this).attr('id');

  var tmpName = jQuery(this).attr('data-name');
  arrNames.push(tmpName);
  var tmpScene = new ScrollMagic.Scene({
    triggerElement: "#"+tmpID,
    duration:jQuery(this).parent('.cont_sec').height()
  })
  
  .addTo(controller)
  .on("enter leave", function (e) {
    //$("#state").text(e.type == "enter" ? "inside" : "outside");
    
    //console.log(e.currentTarget.triggerElement().id  );
    var triggerID = e.currentTarget.triggerElement().id ;
    var name = jQuery('#'+ triggerID).attr('data-name');
    console.log(name);
  //  jQuery('.titular_page').text(name);



  })
  

  arrScenes.push(tmpScene);

});

*/

/*
	new ScrollMagic.Scene({triggerElement: "#sec1"})
					.setClassToggle("#high1", "active") // add class toggle
					.addIndicators() // add indicators (requires plugin)
					.addTo(controller);
*/


/*
jQuery.scrollify({
  section : ".section",
  setHeights:false
});

jQuery('.nav_prin a').on('click', function(ev){
  ev.preventDefault();
  //var nameGo = jQuery(this).attr('href');
  var num = jQuery('.nav_prin a').index(jQuery(this));
  jQuery.scrollify.move(num);
 
});  

*/



 jQuery('html').scrollWithEase({
  frameRate: 60,
  animationTime: 1000,
  stepSize: 15,
  pulseAlgorithm: true,
  pulseScale: 8,
  pulseNormalize: 1,
  accelerationDelta: 20,
  accelerationMax: 1,
  keyboardSupport: true,
  arrowScroll: 50   
});

 
resize();


//NAvegacion
 

if(jQuery('.item_past').length < totalThumbs ){

    jQuery('#nextPage').removeClass('inhabil');
}

}

jQuery(window).on('resize', function(){

     resize();

});


function resize(){

  bannerHeight = jQuery('.banner').outerHeight(true) ;

  //var ladoDer = jQuery(window).width() - jQuery('.cont_sec').outerWidth(true);
  var ladoDer = jQuery(window).width() - jQuery('.container').width();

  //alert(jQuery('.main').outerWidth() + " / " +jQuery(window).width() );
  ladoDer/=2;
 

 // alert(ladoDer);

 // jQuery('.brand_fixed').css('right', ladoDer);
 // ladoDer-=50;
  //jQuery('.tag_line').css('right' , ladoDer);

  jQuery('.brand_fixed').css('right', ladoDer +"px" );
  jQuery('.img_about').css('right', ladoDer +"px" );


  var altTit = 0;

  jQuery('.tit_ponencia').each(function(t){

    console.log(jQuery(this).css('height') );

    altTit = Math.max( altTit, jQuery(this).height() );

  });

  jQuery('.tit_ponencia').css('min-height', altTit);
  

}



//SCROLL



jQuery(window).on('scroll', function(ev){

 
  scrollTop = jQuery(window).scrollTop();



  if(scrollTop > bannerHeight){

  //  $('.banner').addClass('minibar');

    jQuery('.banner').addClass('minibar_nu');

  }else{

  //  $('.banner').removeClass('minibar');

    jQuery('.banner').removeClass('minibar_nu');

  }

 

  jQuery('.baix_punts').width( jQuery('.swc-single_ok').width()   );
  jQuery('.baix_punts').height( jQuery('.swc-single_ok').height()   );

  jQuery('.marco_foto').height(jQuery('#baix_fotos_puntos').height() );
  jQuery('.marco_foto').width(jQuery('#baix_fotos_puntos').width() );

  var bfOffset = jQuery('#baix_fotos_puntos').position();

  jQuery('.marco_foto').css('top', bfOffset.top  );
  jQuery('.marco_foto').css('left', bfOffset.left  );

});